import { render } from "./purchase-complete.vue?vue&type=template&id=35fd9a07&ts=true"
import script from "./purchase-complete.vue?vue&type=script&lang=ts"
export * from "./purchase-complete.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__